'use client';

import { useEffect } from 'react';

const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
const APPLE_SDK_SCRIPT_ID = 'apple-id-sdk';

/**
 * Lazy-loads the Apple ID JS SDK on mount and removes the script tag on
 * unmount. The current OAuth flow doesn't actively call `AppleID.auth.signIn()`
 * — the Apple sign-in button just navigates to `/api/auth/apple/start`, which
 * server-redirects to Apple's authorize endpoint — so the SDK is loaded
 * defensively in case future flows need its client-side helpers (e.g. one-tap
 * popup or post-redirect token verification). Keep it scoped to the button's
 * lifecycle so we don't pay the load cost on every page.
 */
export function useAppleAuth(): void {
  useEffect(() => {
    if (document.getElementById(APPLE_SDK_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = APPLE_SDK_SCRIPT_ID;
    script.src = APPLE_SDK_URL;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById(APPLE_SDK_SCRIPT_ID);
      if (existing) existing.remove();
    };
  }, []);
}
